<div [formGroup]="form">
    <div class="row">
        <div class="apc-form-card">
            <span class="title">{{'person.extras.metadata' | translate}}</span>
            <div class="container-fluid my-2">
                <div class="row">
                    <div class="form-group col-lg-6">
                        <apc-form-select class="autoHeight" formControlName="extraTypeIdentifier" [items]="typesDropdown"
                            (isChanged)="typeChange()" [renderValue]="findDropdownRenderValue()"
                            [optionDescription]="['description']" [valueDescription]="true" [isRequired]="true">
                            <label label>{{'person.extras.typology' | translate}}</label>
                        </apc-form-select>
                    </div>
                    <div class="form-group col-lg-6">
                        <apc-form-input *ngIf="inputType !== 'switch'" [class]="'form-control'" formControlName="value"
                            [type]="inputType" [isRequired]="true">
                            <label label>{{'person.extras.value' | translate}}</label>
                        </apc-form-input>
                        <apc-ui-switch *ngIf="inputType === 'switch'" style="float:left" formControlName="value">
                            <span style="margin-left: -17px" label>{{'person.extras.value' | translate}} *</span>
                        </apc-ui-switch>
                    </div>
                    <div class="form-group col-lg-12 mt-3">
                        <label>{{'person.extras.description' | translate}}</label>
                        <apc-form-input [class]="'form-control'" formControlName="description" [type]="'textarea'"
                            [rows]="'4'">
                        </apc-form-input>
                    </div>
                </div>
            </div>
        </div>
    </div>